import * as contentful from 'contentful';

export const client = contentful.createClient({
    space: "nkgu3wxwk2os",
    accessToken: "F1-CO6rE6KyUO5_GiByIrmAzgehzDtkNS9AIHRpJZLc"
})